import { LabelAndValue } from '@saas/interfaces/core'
import {
    INSIConnectorResultDataIdentityInformation,
    INSIConnectorResultDataPatientHistoryValues,
    INSIConnectorResultDataPatientHistoryValuesKeys,
    INSIConnectorResultNumberEnum,
} from '@saas/interfaces/insi'

const identityInformationsTranslation: Record<keyof INSIConnectorResultDataIdentityInformation, string> = {
    i_sex: 'sexe',
    s_birthDate: 'date de naissance',
    s_birthGiven: 'prénom(s) de naissance',
    s_birthName: 'nom de naissance',
    s_birthPlace: 'lieu de naissance (code insee)',
    s_given: 'prénom(s) utilisé(s)',
}

const patientHistoryValuesTranslation: Record<keyof INSIConnectorResultDataPatientHistoryValues, string> = {
    s_key: 'clé',
    s_oid: 'OID',
    s_value: 'matricule INS',
    s_endDate: 'date de fin',
    s_startDate: 'date de début',
}

const translateSexValue = (value: number | undefined) => {
    if (value === 2) return 'masculin'
    if (value === 3) return 'féminin'
    return 'sexe inconnu'
}

export const buildIdentityInformations = (identityInformations: INSIConnectorResultDataIdentityInformation): string =>
    JSON.stringify(identityInformations)

export const translateIdentityInformations = (identityInformations: INSIConnectorResultDataIdentityInformation) =>
    Object.keys(identityInformations).reduce<LabelAndValue<string | INSIConnectorResultNumberEnum>[]>((prev, curr) => {
        const key = curr as keyof INSIConnectorResultDataIdentityInformation
        const value = identityInformations[key]
        const translated = key === 'i_sex' ? translateSexValue(parseInt(value.toString())) : value

        prev.push({
            label: identityInformationsTranslation[key],
            value: translated,
        })

        return prev
    }, [])

function isINSIConnectorResultDataPatientHistoryValuesKey(
    key: string,
): key is INSIConnectorResultDataPatientHistoryValuesKeys {
    const keys: INSIConnectorResultDataPatientHistoryValuesKeys[] = ['s_key', 's_oid', 's_value']
    return keys.includes(key as INSIConnectorResultDataPatientHistoryValuesKeys)
}

export const translatePatientHistoryLabel = (raw: string) => {
    if (isINSIConnectorResultDataPatientHistoryValuesKey(raw)) {
        return patientHistoryValuesTranslation[raw]
    }

    return raw
}
